var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 15,
    viewBox: "0 0 15 15",
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.95102 1.09966c-.67677-.06547-1.37385-.09966-2.08582-.09966-.71198 0-1.40906.03419-2.08583.09967-.74472.07205-1.31443.82687-1.34807 1.74596-.05195 1.4195-.07931 2.89306-.07931 4.40437 0 1.5113.02736 2.9849.07931 4.4044.03364.9191.60335 1.6739 1.34807 1.7459.67677.0655 1.37385.0997 2.08583.0997.71197 0 1.40905-.0342 2.08582-.0997.74471-.072 1.31442-.8268 1.34806-1.7459.01854-.5065.03394-1.0198.04609-1.5393v-5.73014c-.01215-.5195-.02755-1.03286-.04609-1.53933-.03364-.91909-.60335-1.67392-1.34806-1.74597z",
    fill: "#d7e0ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#4147d5",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.64089 7.34043c0 .4957.06944 1.19353.14108 1.78151.07301.59927.67263.98316 1.22523.74016 1.0117-.44476 1.9441-1.10454 2.5968-2.06406.1879-.27639.188-.63885 0-.91525-.6526-.95955-1.5851-1.61931-2.5967-2.06405-.5527-.24294-1.15224.14087-1.22528.74011-.07166.588-.14113 1.28585-.14113 1.78158z",
    fill: "#fff",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.29908 2.84563c-.03363-.91909-.60335-1.67392-1.34806-1.74597-.67677-.06547-1.37385-.09966-2.08582-.09966-.71198 0-1.40906.03419-2.08583.09967-.74472.07205-1.31443.82687-1.34807 1.74596-.05195 1.4195-.07931 2.89306-.07931 4.40437 0 1.5113.02736 2.9849.07931 4.4044.03364.9191.60335 1.6739 1.34807 1.7459.67677.0655 1.37385.0997 2.08583.0997.71197 0 1.40905-.0342 2.08582-.0997.74471-.072 1.31443-.8268 1.34806-1.7459"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.50394 7.34045h5.13693",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.3c36fe149e2711909df891d852247ffe.svg";
export { ForwardRef as ReactComponent };